const classes = {
  customSliderContainer: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '10px',
  },
};

export default classes;
